import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000, // Data considered fresh for 1 second
      retry: 2,
      refetchOnWindowFocus: false,
      refetchInterval: 1000, // Auto-refetch every 1 second for real-time updates
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            className: 'bg-command-panel text-gray-100 border border-command-border',
            duration: 4000,
            style: {
              background: '#111820',
              color: '#f3f4f6',
              border: '1px solid #1e2a3a',
            },
            success: {
              iconTheme: {
                primary: '#00cc66',
                secondary: '#111820',
              },
            },
            error: {
              iconTheme: {
                primary: '#ff4444',
                secondary: '#111820',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

